import { Component } from '@angular/core';

@Component({
    selector: 'sgt-objetivo-campanha-badge-venda',
    templateUrl: './objetivo-campanha-badge-venda.component.html',
    styleUrls: ['./objetivo-campanha-badge-venda.component.less']
})
export class ObjetivoCampanhaBadgeVendaComponent {

}
